import { render } from "./AutomaticTerminal.vue?vue&type=template&id=927aa5c4&scoped=true"
import script from "./AutomaticTerminal.vue?vue&type=script&lang=js"
export * from "./AutomaticTerminal.vue?vue&type=script&lang=js"

import "./AutomaticTerminal.vue?vue&type=style&index=0&id=927aa5c4&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-927aa5c4"]])

export default __exports__